module.exports = __webpack_public_path__ + "img/20201102_195123.619c714e.jpg";